import { composeIO } from 'react-compose-io'
import { loginIO } from './Login.IO'
import { LoginView } from './Login.View'

export const Login = composeIO(LoginView, loginIO)
